import { useEffect, useState } from "react";

export type RecordEventsStatus = "connecting" | "connected" | "reconnecting" | "unavailable";

export function useRecordEvents() {
  const [status, setStatus] = useState<RecordEventsStatus>("connecting");
  const [hasUpdate, setHasUpdate] = useState(false);

  useEffect(() => {
    if (typeof EventSource === "undefined") {
      setStatus("unavailable");
      return;
    }

    const source = new EventSource("/api/events");
    source.onopen = () => setStatus("connected");
    source.onerror = () => setStatus("reconnecting");
    source.onmessage = (event) => {
      try {
        const payload = JSON.parse(event.data) as { type?: string };
        if (payload.type === "data_changed") setHasUpdate(true);
      } catch {
        // Ignore malformed event frames and leave the current page usable.
      }
    };
    return () => source.close();
  }, []);

  return {
    status,
    hasUpdate,
    clearUpdate: () => setHasUpdate(false),
  };
}
